// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WasVergleichenWirRouteImport } from './routes/was-vergleichen-wir'
import { Route as WasIstEnergyPrime360RouteImport } from './routes/was-ist-energy-prime-360'
import { Route as WasAnalysierenWirRouteImport } from './routes/was-analysieren-wir'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProjektBeschreibenRouteImport } from './routes/projekt-beschreiben'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as ErgebnisRouteImport } from './routes/ergebnis'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AgbRouteImport } from './routes/agb'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app.index'
import { Route as AuthenticatedAppWorkflowsRouteImport } from './routes/_authenticated/app.workflows'
import { Route as AuthenticatedAppValidationRouteImport } from './routes/_authenticated/app.validation'
import { Route as AuthenticatedAppSalesRouteImport } from './routes/_authenticated/app.sales'
import { Route as AuthenticatedAppPortalRouteImport } from './routes/_authenticated/app.portal'
import { Route as AuthenticatedAppMonitoringRouteImport } from './routes/_authenticated/app.monitoring'
import { Route as AuthenticatedAppManagementRouteImport } from './routes/_authenticated/app.management'
import { Route as AuthenticatedAppGovernanceRouteImport } from './routes/_authenticated/app.governance'
import { Route as AuthenticatedAppExpertRouteImport } from './routes/_authenticated/app.expert'
import { Route as AuthenticatedAppCrmRouteImport } from './routes/_authenticated/app.crm'
import { Route as AuthenticatedAppCoverageRouteImport } from './routes/_authenticated/app.coverage'
import { Route as AuthenticatedAppApprovalsRouteImport } from './routes/_authenticated/app.approvals'
import { Route as AuthenticatedAppAngelikaRouteImport } from './routes/_authenticated/app.angelika'
import { Route as AuthenticatedAppAdminRouteImport } from './routes/_authenticated/app.admin'
import { Route as AuthenticatedAppDecisionProjectIdRouteImport } from './routes/_authenticated/app.decision.$projectId'
import { Route as AuthenticatedAppCrmIndexRouteImport } from './routes/_authenticated/app.crm.index'
import { Route as AuthenticatedAppCrmProjectsRouteImport } from './routes/_authenticated/app.crm.projects'
import { Route as AuthenticatedAppCrmLeadsRouteImport } from './routes/_authenticated/app.crm.leads'
import { Route as AuthenticatedAppCrmCustomersRouteImport } from './routes/_authenticated/app.crm.customers'
import { Route as AuthenticatedAppProjectsIdUploadsRouteImport } from './routes/_authenticated/app.projects.$id.uploads'
import { Route as AuthenticatedAppProjectsIdDocumentsRouteImport } from './routes/_authenticated/app.projects.$id.documents'
import { Route as AuthenticatedAppCrmProjectsIndexRouteImport } from './routes/_authenticated/app.crm.projects.index'
import { Route as AuthenticatedAppCrmProjectsIdRouteImport } from './routes/_authenticated/app.crm.projects.$id'
import { Route as AuthenticatedAppCrmCustomersIdRouteImport } from './routes/_authenticated/app.crm.customers.$id'
import { Route as AuthenticatedAppCrmProjectsIdRunsRunIdRouteImport } from './routes/_authenticated/app.crm.projects.$id.runs.$runId'

const WasVergleichenWirRoute = WasVergleichenWirRouteImport.update({
            id: '/was-vergleichen-wir',path: '/was-vergleichen-wir',getParentRoute: () => rootRouteImport
          })
const WasIstEnergyPrime360Route = WasIstEnergyPrime360RouteImport.update({
            id: '/was-ist-energy-prime-360',path: '/was-ist-energy-prime-360',getParentRoute: () => rootRouteImport
          })
const WasAnalysierenWirRoute = WasAnalysierenWirRouteImport.update({
            id: '/was-analysieren-wir',path: '/was-analysieren-wir',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ProjektBeschreibenRoute = ProjektBeschreibenRouteImport.update({
            id: '/projekt-beschreiben',path: '/projekt-beschreiben',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const ErgebnisRoute = ErgebnisRouteImport.update({
            id: '/ergebnis',path: '/ergebnis',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AgbRoute = AgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppWorkflowsRoute = AuthenticatedAppWorkflowsRouteImport.update({
            id: '/app/workflows',path: '/app/workflows',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppValidationRoute = AuthenticatedAppValidationRouteImport.update({
            id: '/app/validation',path: '/app/validation',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppSalesRoute = AuthenticatedAppSalesRouteImport.update({
            id: '/app/sales',path: '/app/sales',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppPortalRoute = AuthenticatedAppPortalRouteImport.update({
            id: '/app/portal',path: '/app/portal',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppMonitoringRoute = AuthenticatedAppMonitoringRouteImport.update({
            id: '/app/monitoring',path: '/app/monitoring',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppManagementRoute = AuthenticatedAppManagementRouteImport.update({
            id: '/app/management',path: '/app/management',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppGovernanceRoute = AuthenticatedAppGovernanceRouteImport.update({
            id: '/app/governance',path: '/app/governance',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppExpertRoute = AuthenticatedAppExpertRouteImport.update({
            id: '/app/expert',path: '/app/expert',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppCrmRoute = AuthenticatedAppCrmRouteImport.update({
            id: '/app/crm',path: '/app/crm',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppCoverageRoute = AuthenticatedAppCoverageRouteImport.update({
            id: '/app/coverage',path: '/app/coverage',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppApprovalsRoute = AuthenticatedAppApprovalsRouteImport.update({
            id: '/app/approvals',path: '/app/approvals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppAngelikaRoute = AuthenticatedAppAngelikaRouteImport.update({
            id: '/app/angelika',path: '/app/angelika',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppAdminRoute = AuthenticatedAppAdminRouteImport.update({
            id: '/app/admin',path: '/app/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppDecisionProjectIdRoute = AuthenticatedAppDecisionProjectIdRouteImport.update({
            id: '/app/decision/$projectId',path: '/app/decision/$projectId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppCrmIndexRoute = AuthenticatedAppCrmIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppCrmRoute
          })
const AuthenticatedAppCrmProjectsRoute = AuthenticatedAppCrmProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => AuthenticatedAppCrmRoute
          })
const AuthenticatedAppCrmLeadsRoute = AuthenticatedAppCrmLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthenticatedAppCrmRoute
          })
const AuthenticatedAppCrmCustomersRoute = AuthenticatedAppCrmCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => AuthenticatedAppCrmRoute
          })
const AuthenticatedAppProjectsIdUploadsRoute = AuthenticatedAppProjectsIdUploadsRouteImport.update({
            id: '/app/projects/$id/uploads',path: '/app/projects/$id/uploads',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppProjectsIdDocumentsRoute = AuthenticatedAppProjectsIdDocumentsRouteImport.update({
            id: '/app/projects/$id/documents',path: '/app/projects/$id/documents',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppCrmProjectsIndexRoute = AuthenticatedAppCrmProjectsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppCrmProjectsRoute
          })
const AuthenticatedAppCrmProjectsIdRoute = AuthenticatedAppCrmProjectsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppCrmProjectsRoute
          })
const AuthenticatedAppCrmCustomersIdRoute = AuthenticatedAppCrmCustomersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppCrmCustomersRoute
          })
const AuthenticatedAppCrmProjectsIdRunsRunIdRoute = AuthenticatedAppCrmProjectsIdRunsRunIdRouteImport.update({
            id: '/runs/$runId',path: '/runs/$runId',getParentRoute: () => AuthenticatedAppCrmProjectsIdRoute
          })





const AuthenticatedAppCrmCustomersRouteChildren = {
  AuthenticatedAppCrmCustomersIdRoute: AuthenticatedAppCrmCustomersIdRoute
}

const AuthenticatedAppCrmCustomersRouteWithChildren = AuthenticatedAppCrmCustomersRoute._addFileChildren(AuthenticatedAppCrmCustomersRouteChildren)




const AuthenticatedAppCrmProjectsIdRouteChildren = {
  AuthenticatedAppCrmProjectsIdRunsRunIdRoute: AuthenticatedAppCrmProjectsIdRunsRunIdRoute
}

const AuthenticatedAppCrmProjectsIdRouteWithChildren = AuthenticatedAppCrmProjectsIdRoute._addFileChildren(AuthenticatedAppCrmProjectsIdRouteChildren)



const AuthenticatedAppCrmProjectsRouteChildren = {
  AuthenticatedAppCrmProjectsIdRoute: AuthenticatedAppCrmProjectsIdRouteWithChildren,AuthenticatedAppCrmProjectsIndexRoute: AuthenticatedAppCrmProjectsIndexRoute
}

const AuthenticatedAppCrmProjectsRouteWithChildren = AuthenticatedAppCrmProjectsRoute._addFileChildren(AuthenticatedAppCrmProjectsRouteChildren)



const AuthenticatedAppCrmRouteChildren = {
  AuthenticatedAppCrmCustomersRoute: AuthenticatedAppCrmCustomersRouteWithChildren,AuthenticatedAppCrmLeadsRoute: AuthenticatedAppCrmLeadsRoute,AuthenticatedAppCrmProjectsRoute: AuthenticatedAppCrmProjectsRouteWithChildren,AuthenticatedAppCrmIndexRoute: AuthenticatedAppCrmIndexRoute
}

const AuthenticatedAppCrmRouteWithChildren = AuthenticatedAppCrmRoute._addFileChildren(AuthenticatedAppCrmRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAppAdminRoute: AuthenticatedAppAdminRoute,AuthenticatedAppAngelikaRoute: AuthenticatedAppAngelikaRoute,AuthenticatedAppApprovalsRoute: AuthenticatedAppApprovalsRoute,AuthenticatedAppCoverageRoute: AuthenticatedAppCoverageRoute,AuthenticatedAppCrmRoute: AuthenticatedAppCrmRouteWithChildren,AuthenticatedAppExpertRoute: AuthenticatedAppExpertRoute,AuthenticatedAppGovernanceRoute: AuthenticatedAppGovernanceRoute,AuthenticatedAppManagementRoute: AuthenticatedAppManagementRoute,AuthenticatedAppMonitoringRoute: AuthenticatedAppMonitoringRoute,AuthenticatedAppPortalRoute: AuthenticatedAppPortalRoute,AuthenticatedAppSalesRoute: AuthenticatedAppSalesRoute,AuthenticatedAppValidationRoute: AuthenticatedAppValidationRoute,AuthenticatedAppWorkflowsRoute: AuthenticatedAppWorkflowsRoute,AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,AuthenticatedAppDecisionProjectIdRoute: AuthenticatedAppDecisionProjectIdRoute,AuthenticatedAppProjectsIdDocumentsRoute: AuthenticatedAppProjectsIdDocumentsRoute,AuthenticatedAppProjectsIdUploadsRoute: AuthenticatedAppProjectsIdUploadsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AgbRoute: AgbRoute,AuthRoute: AuthRoute,DatenschutzRoute: DatenschutzRoute,ErgebnisRoute: ErgebnisRoute,ImpressumRoute: ImpressumRoute,ProjektBeschreibenRoute: ProjektBeschreibenRoute,ResetPasswordRoute: ResetPasswordRoute,WasAnalysierenWirRoute: WasAnalysierenWirRoute,WasIstEnergyPrime360Route: WasIstEnergyPrime360Route,WasVergleichenWirRoute: WasVergleichenWirRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)